import React, { useState, useEffect } from "react";
import Modal from "react-modal";

import Portada from "./Portada.js";
import Enviar from "./Enviar.js";
import Grid from "./Grid.js";
import Pedido from "./Pedido.js";

import "../App.css";

const Shop_tiendas = () => {
  const [modal_is_open, modal_is_open_update] = useState(false);
  const [checkout_is_open, checkout_is_open_update] = useState(false);

  const [n_total, set_n_total] = useState(0);
  const [price_total, set_price_total] = useState(0);
  const [delivery, delivery_update] = useState(2490);
  const [delivery_real, delivery_real_update] = useState(2490);
  const [total, total_update] = useState(2490);

  const [store, set_store] = useState({
    bank_bank: "Banco Estado",
    bank_number: "18396969",
    bank_rut: "18.396.969-2",
    bank_type: "Cuenta Rut / Vista",
    delivery: true,
    delivery_comunas: [],
    delivery_price: 0,
    facebook: "",
    instagram: "",
    mail: "hola@cornerdog.cl",
    name: "Cornerdog",
    phone: "966564743",
    retiro: true,
    retiro_details: "Av el Cerro 1731, Providencia.",
  });
  const [products, set_products] = useState([
    // {
    //   off: 0,
    //   agotado: false,
    //   name: "(T) Jerky de Vacuno Angus",
    //   tag: "80 gr",
    //   category: "Jerky",
    //   price: 1490,
    //   img1: "/img/productos/vacuno.jpg",
    //   img2: "/img/productos/jerky2.jpg",
    //   img3: "/img/productos/jv_3.jpg",
    //   n: 0,
    //   tam: "/img/tam_pmg.png",
    //   beneficios: [1, 1, 0.2, 0.2, 0.2, 0.2, 1, 0.2],
    //   desc1:
    //     "Snack estrella. Consta de deliciosos trozos naturales de carne de vacuno, secado lentamente con aire tibio para conservar su sabor, blandura y propiedades nutritivas.",
    //   desc2:
    //     "Al ser 100% carne natural deshidratada, aporta gran cantidad de proteínas, es alto en colágeno y ayuda a regenerar músculos y articulaciones. Es uno de nuestros productos de mayor demanda.",
    // },
    // {
    //   off: 0,
    //   agotado: false,
    //   name: "(T) Jerky de Pollo Broiler",
    //   tag: "80 gr",
    //   category: "Jerky",
    //   price: 1490,
    //   img1: "/img/productos/pollo.jpg",
    //   img2: "/img/productos/jerky2.jpg",
    //   img3: "/img/productos/jp_3.jpg",
    //   n: 0,
    //   tam: "/img/tam_pmg.png",
    //   beneficios: [1, 1, 0.2, 0.2, 0.2, 0.2, 1, 0.2],
    //   desc1:
    //     "Trozos de carne fresca de pollo deshidratado, con sabores y aromas extremadamente atractivos para cualquier mascota. Además tiene una consistencia blanda, siendo muy agradable para razas pequeñas.",
    //   desc2:
    //     "Se caracteriza por ser muy usado como recompensa y se utiliza efectivamente en la enseñanza de todo tipo de razas. Es alto en colágeno.",
    // },
    // {
    //   off: 0,
    //   agotado: false,
    //   name: "(T) Jerky de Salmón Atlántico",
    //   tag: "80 gr",
    //   category: "Jerky",
    //   price: 1490,
    //   img1: "/img/productos/salmon.jpg",
    //   img2: "/img/productos/jerky2.jpg",
    //   img3: "/img/productos/js_3.jpg",
    //   n: 0,
    //   tam: "/img/tam_pmg.png",
    //   beneficios: [1, 1, 1, 0.2, 0.2, 0.2, 1, 0.2],
    //   desc1:
    //     "Trozos de carne fresca de salmón deshidratado, con sabores y aromas extremadamente atractivos para cualquier mascota. Es muy popular entre toda clase de perros, siendo uno de los Jerky más vendidos.",
    //   desc2:
    //     "Es alto en proteínas y colágeno, manteniendo tu mascota sana, regenerando sus articulaciones y fortaleciendo sus músculos.",
    // },
    // {
    //   off: 0,
    //   agotado: false,
    //   name: "(T) Jerky de Cordero Patagónico",
    //   category: "Jerky",
    //   tag: "80 gr",
    //   price: 1490,
    //   img1: "/img/productos/salmon.jpg",
    //   img2: "/img/productos/jerky2.jpg",
    //   img3: "/img/productos/jv_3.jpg",
    //   n: 0,
    //   tam: "/img/tam_pmg.png",
    //   beneficios: [1, 1, 0.2, 0.2, 0.2, 0.2, 1, 0.2],
    //   desc1:
    //     "Nuevo sabor, nuevos beneficios. Te traemos un nuevo Jerky de Cordero criado en la patagonia chilena, en un ambiente completamente libre.",
    //   desc2:
    //     "Al ser 100% carne natural deshidratada, aporta gran cantidad de proteínas, es alto en colágeno y ayuda a regenerar músculos y articulaciones. Tenemos Stock limitado!",
    // },
    {
      off: 0,
      agotado: false,
      name: "(T) Beef Gristle",
      tag: "15 cm",
      category: "Premium",
      price: 1490,
      img1: "/img/productos/traquea1.jpg",
      img2: "/img/productos/traquea2.jpg",
      img3: "/img/productos/sb_3.jpeg",
      n: 0,
      tam: "/img/tam_pmg.png",
      beneficios: [1, 1, 0.2, 0.2, 1, 1, 1, 1],
      desc1:
        "Es un producto de 15 cms, previamente horneado, más blando que un hueso y más duro que un Bully Stick. Tiene una consistencia agradable para la mordida y gran sabor. Tiene un solo ingrediente: Tráquea de vacuno horneada.",
      desc2:
        "Presenta alto contenido de colágeno, ayudando con el fortalecimiento y la regeneración de articulaciones. Ayuda también con la limpieza de dientes y la eliminación de sarro, la liberación de ansiedad y la mejora de la mordida de tu mascota.",
    },
    {
      off: 0,
      agotado: false,
      name: "(T) Big Beef Gristle",
      category: "Premium",
      tag: "30 cm",
      price: 2590,
      img1: "/img/productos/traquealarga1.jpg",
      img2: "/img/productos/traquealarga2.jpg",
      img3: "/img/productos/traquealarga3.jpg",
      n: 0,
      tam: "/img/tam_mg.png",
      beneficios: [1, 1, 0.2, 0.2, 1, 1, 1, 1],
      desc1:
        "¿A tu mascota le gustó el Beef, pero se le hace poco? Si está con hambre, tenemos un nuevo Beef Gristle pero con el doble de largo... y el doble de sabor.",
      desc2:
        "Presenta alto contenido de colágeno, ayudando con el fortalecimiento y la regeneración de articulaciones. Ayuda también con la limpieza de dientes y la eliminación de sarro, la liberación de ansiedad y la mejora de la mordida de tu mascota.",
    },
    {
      off: 0,
      agotado: false,
      name: "(T) Bully Stick",
      tag: "15 cm",
      category: "Premium",
      price: 1490,
      img1: "/img/productos/b_1.jpg",
      img2: "/img/productos/b_2.jpg",
      img3: "/img/productos/b_3.jpg",
      n: 0,
      tam: "/img/tam_pmg.png",
      beneficios: [1, 0.2, 0.2, 1, 0.2, 1, 1, 1],
      desc1:
        "Increíble Stick de vacuno de 15 cm, horneado y de consistencia firme pero sabrosa. No astilla, no deja manchas y tiene un aroma irresistible.",
      desc2:
        "Creado en base a carne deshidratada, este Snack Natural es alto en proteínas y no contiene grasas saturadas. Es uno de nuestros productos más vendidos.",
    },
    {
      off: 0,
      agotado: false,
      name: "(T) Big Bully Stick",
      category: "Premium",
      tag: "30 cm",
      price: 2590,
      img1: "/img/productos/bullylargo1.jpg",
      img2: "/img/productos/b_2.jpg",
      img3: "/img/productos/bullylargo3.jpg",
      n: 0,
      tam: "/img/tam_mg.png",
      beneficios: [1, 0.2, 0.2, 1, 0.2, 1, 1, 1],
      desc1:
        "¿A tu mascota le gustó el Bully, pero se le hace poco? Te tenemos la receta perfecta: un nuevo Bully Stick pero con el doble de largo... y el doble de sabor.",
      desc2:
        "Creado en base a carne deshidratada, este Snack Natural es alto en proteínas y no contiene grasas saturadas. Es uno de nuestros productos más vendidos.",
    },
    {
      off: 0,
      agotado: false,
      name: "(T) Pig Snack Grande",
      tag: "12 cm",
      category: "Premium",
      price: 990,
      img1: "/img/productos/pig1.jpg",
      img2: "/img/productos/pig2.jpg",
      img3: "/img/productos/og_3.jpg",
      n: 0,
      tam: "/img/tam_pmg.png",
      beneficios: [1, 1, 0.2, 1, 0.2, 0.2, 0.2, 0.2],
      desc1:
        "Naturalmente horneado, este Snack presenta alto contenido de colágeno que ayuda a mejorar la piel de tu mascota. Además fortalece tejidos y articulaciones.",
      desc2:
        "Destaca por ser un Snack sabroso, de agradable consistencia y tamaño perfecto. Es muy resistente, duradero, no deja manchas y no tiene olor.",
    },
    {
      off: 0,
      agotado: false,
      name: "(T) Hueso de Cerdo",
      category: "Huesos",
      tag: "20 cm",
      price: 1590,
      img1: "/img/productos/h_1.jpg",
      img2: "/img/productos/h_2.jpg",
      img3: "/img/productos/h_3.jpg",
      n: 0,
      tam: "/img/tam_mg.png",
      beneficios: [1, 0.2, 0.2, 0.2, 0.2, 1, 1, 1],
      desc1:
        "Hueso horneado de 20 cms que destaca por ser muy sabroso y atractivo para perros medianos y grandes. Debido a que está horneado no se astilla al ser mordido, no se desarma y no deja manchas.",
      desc2:
        "Entre sus beneficios están la limpieza de dientes, el fortalecimiento de la mandíbula, el manejo de la ansiedad y la mejora de la piel. Muy recomendado para mascotas de tamaño mediano y grande.",
    },
    {
      off: 0,
      agotado: false,
      name: "(T) Monster Bone",
      category: "Huesos",
      tag: "50 cm",
      price: 3290,
      img1: "/img/productos/h_1.jpg",
      img2: "/img/productos/h_2.jpg",
      img3: "/img/productos/h_3.jpg",
      n: 0,
      tam: "/img/tam_mg.png",
      beneficios: [1, 0.2, 0.2, 0.2, 0.2, 1, 1, 1],
      desc1:
        "Hueso horneado de 50 cms que destaca por ser muy sabroso y atractivo para perros grandes. Debido a que está horneado no se astilla al ser mordido, no se desarma y no deja manchas.",
      desc2:
        "Entre sus beneficios están la limpieza de dientes, el fortalecimiento de la mandíbula, el manejo de la ansiedad y la mejora de la piel. Muy recomendado para mascotas de tamaño grande.",
    },
  ]);
  const [filter, set_filter] = useState(["Jerky", "Premium", "Huesos"]);

  const add = (e) => {
    const findIndex = products.findIndex((x) => x.name === e);
    let items = products;
    let item = products[findIndex];
    item.n = item.n + 1;
    items[findIndex] = item;
    set_products([...items]);
  };

  const remove = (e) => {
    const findIndex = products.findIndex((x) => x.name === e);
    let items = products;
    let item = products[findIndex];
    item.n = item.n - 1;
    items[findIndex] = item;
    set_products([...items]);
  };

  const delivery_por_comuna = (e) => {
    delivery_real_update(e);
  };

  useEffect(() => {
    total_update(price_total + delivery);
  }, [n_total, delivery]);

  useEffect(() => {
    delivery_update(delivery_real);
  }, [delivery_real]);

  useEffect(() => {
    set_n_total(products.reduce((s, a) => s + a.n, 0));
    set_price_total(products.reduce((s, a) => s + a.n * a.price, 0));
  }, [products]);

  return (
    <div>
      <Portada img="/img/portada8.jpg" name_tag="Tiendas"></Portada>
      <p style={{ fontSize: "25px", margin: "50px", fontWeight: "400" }}>
        *Mínimo 40 unidades surtidas.
      </p>
      <p style={{ fontSize: "25px", margin: "50px", fontWeight: "800" }}>
        *Antes de comprar preguntar por Stock{" "}
        <a
          rel="noopener noreferrer"
          target="_blank"
          href="https://api.whatsapp.com/send/?phone=56966564743&text&app_absent=0"
        >
          aquí
        </a>
      </p>
      <Grid
        products={products}
        filter={filter}
        add={add}
        remove={remove}
        modal_beneficios={() => modal_is_open_update(true)}
      ></Grid>

      <Pedido
        n_total={n_total}
        price_total={price_total}
        terminar={() =>
          checkout_is_open
            ? checkout_is_open_update(false)
            : checkout_is_open_update(true)
        }
        persona={false}
      ></Pedido>

      <Modal
        isOpen={modal_is_open}
        onRequestClose={() => modal_is_open_update(false)}
        style={{
          content: {
            padding: "0",
            margin: "auto",
            top: "5px",
            right: "5px",
            bottom: "5px",
            left: "5px",
            borderRadius: "15px",
            maxWidth: "450px",
            maxHeight: "900px",
            zIndex: "5",
          },
        }}
      >
        <div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              marginTop: "20px",
            }}
          >
            <img
              style={{
                width: "70px",
                height: "70px",
                margin: "20px 0px 0px 10px",
              }}
              src="/img/b_1.png"
              alt=""
            ></img>
            <div>
              <p
                style={{
                  fontSize: "17px",
                  margin: "20px",
                  opacity: "0.9",
                  textAlign: "start",
                  color: "black",
                }}
              >
                100% Natural
              </p>
              <p
                style={{
                  fontSize: "15px",
                  margin: "20px",
                  textAlign: "justify",
                  opacity: "0.9",
                  fontStyle: "italic",
                }}
              >
                Todos nuestros productos son completamente naturales, sin
                aditivos, saborizantes o colorantes de ningún tipo. La mayoría,
                incluso, están creados con un solo ingrediente.
              </p>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            <img
              style={{
                width: "70px",
                height: "70px",
                margin: "20px 0px 0px 10px",
              }}
              src="/img/b_2.png"
              alt=""
            ></img>
            <div>
              <p
                style={{
                  fontSize: "17px",
                  margin: "20px",
                  opacity: "0.9",
                  textAlign: "start",
                  color: "black",
                }}
              >
                Alto en Colágeno
              </p>
              <p
                style={{
                  fontSize: "15px",
                  margin: "20px",
                  textAlign: "justify",
                  opacity: "0.9",
                  fontStyle: "italic",
                }}
              >
                Es el componente principal de los tejidos conectivos que
                conforman varias partes del cuerpo, incluyendo los tendones, los
                ligamentos, la piel y los músculos. El colágeno desempeña muchas
                funciones importantes, como proporcionar estructura a la piel y
                fortalecer los huesos.
              </p>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            <img
              style={{
                width: "70px",
                height: "70px",
                margin: "20px 0px 0px 10px",
              }}
              src="/img/b_3.png"
              alt=""
            ></img>
            <div>
              <p
                style={{
                  fontSize: "17px",
                  margin: "20px",
                  opacity: "0.9",
                  textAlign: "start",
                  color: "black",
                }}
              >
                Alto en Omega 3 y 6
              </p>
              <p
                style={{
                  fontSize: "15px",
                  margin: "20px",
                  textAlign: "justify",
                  opacity: "0.9",
                  fontStyle: "italic",
                }}
              >
                Son un tipo de grasa poliinsaturada que necesitamos para
                fortalecer las neuronas y para otras funciones importantes.
                Ayudan a mantener el corazón sano y protegido contra un
                accidente cerebrovascular, previenen el cáncer y tienen efectos
                antidepresivos.
              </p>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            <img
              style={{
                width: "70px",
                height: "70px",
                margin: "20px 0px 0px 10px",
              }}
              src="/img/b_4.png"
              alt=""
            ></img>
            <div>
              <p
                style={{
                  fontSize: "17px",
                  margin: "20px",
                  opacity: "0.9",
                  textAlign: "start",
                  color: "black",
                }}
              >
                Alto en proteínas
              </p>
              <p
                style={{
                  fontSize: "15px",
                  margin: "20px",
                  textAlign: "justify",
                  opacity: "0.9",
                  fontStyle: "italic",
                }}
              >
                No solo ayuda a prevenir la degradación muscular, sino que
                también puede ayudar a desarrollar y fortalecer los músculos. La
                combinación de ejercicio regular con un alto consumo de
                proteínas promueve el crecimiento muscular y el fortalecimiento.
              </p>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            <img
              style={{
                width: "70px",
                height: "70px",
                margin: "20px 0px 0px 10px",
              }}
              src="/img/b_5.png"
              alt=""
            ></img>
            <div>
              <p
                style={{
                  fontSize: "17px",
                  margin: "20px",
                  opacity: "0.9",
                  textAlign: "start",
                  color: "black",
                }}
              >
                Alto en Glucosamina
              </p>
              <p
                style={{
                  fontSize: "15px",
                  margin: "20px",
                  textAlign: "justify",
                  opacity: "0.9",
                  fontStyle: "italic",
                }}
              >
                Es una de las sustancias del cuerpo que se utiliza para formar
                cartílago. Ayuda a regenerar las articulaciones y que se muevan
                con mayor suavidad. Es especialmente importante para perros que
                ya no están en la etapa de la juventud.
              </p>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            <img
              style={{
                width: "70px",
                height: "70px",
                margin: "20px 0px 0px 10px",
              }}
              src="/img/b_6.png"
              alt=""
            ></img>
            <div>
              <p
                style={{
                  fontSize: "17px",
                  margin: "20px",
                  opacity: "0.9",
                  textAlign: "start",
                  color: "black",
                }}
              >
                Limpia Dientes
              </p>
              <p
                style={{
                  fontSize: "15px",
                  margin: "20px",
                  textAlign: "justify",
                  opacity: "0.9",
                  fontStyle: "italic",
                }}
              >
                Los productos que veas con este símbolo sirven para limpiar
                dientes y eliminar el zarro de la dentadura de forma muy eficaz.
                La limpieza bucal en perros es necesaria para evitar que las
                bacterias se adhieran a la superficie de los dientes tras las
                comidas.
              </p>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            <img
              style={{
                width: "70px",
                height: "70px",
                margin: "20px 0px 0px 10px",
              }}
              src="/img/b_7.png"
              alt=""
            ></img>
            <div>
              <p
                style={{
                  fontSize: "17px",
                  margin: "20px",
                  opacity: "0.9",
                  textAlign: "start",
                  color: "black",
                }}
              >
                Fortalece la Mandíbula
              </p>
              <p
                style={{
                  fontSize: "15px",
                  margin: "20px",
                  textAlign: "justify",
                  opacity: "0.9",
                  fontStyle: "italic",
                }}
              >
                Ya sea debido al Colágeno o a la necesidad de morder los Snacks,
                muchos de nuestros productos ayudan a fortalecer la mandíbula y
                evitar que esté inactiva por mucho tiempo.
              </p>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            <img
              style={{
                width: "70px",
                height: "70px",
                margin: "20px 0px 0px 10px",
              }}
              src="/img/b_8.png"
              alt=""
            ></img>
            <div>
              <p
                style={{
                  fontSize: "17px",
                  margin: "20px",
                  opacity: "0.9",
                  textAlign: "start",
                  color: "black",
                }}
              >
                Libera ansiedad y estrés.
              </p>
              <p
                style={{
                  fontSize: "15px",
                  margin: "20px",
                  textAlign: "justify",
                  opacity: "0.9",
                  fontStyle: "italic",
                }}
              >
                Un perro estresado suele sentirse incómodo ante una situación
                desconocida (como al encontrarse con otros perros) y hace que
                reaccione de una manera exagerada. Eso hará que intente huir o
                que reaccione de forma muy negativa. Por eso, es bueno
                entregarle Snacks que les libere tensión o hacer paseos largos
                en donde puedan liberar energía.
              </p>
            </div>
          </div>
        </div>
        <img
          className="close_button"
          src="/img/close.png"
          alt=""
          onClick={() => modal_is_open_update(false)}
        ></img>
      </Modal>

      <Modal
        isOpen={checkout_is_open}
        onRequestClose={() => checkout_is_open_update(false)}
        style={{
          content: {
            padding: "0",
            margin: "auto",
            top: "0px",
            right: "0px",
            bottom: "0px",
            left: "0px",
            backgroundColor: "rgb(242, 242, 242)",
          },
        }}
      >
        <Enviar
          products={products}
          store={store}
          price_total={price_total}
          delivery={delivery}
          total={total}
          delivery_por_comuna={delivery_por_comuna}
          atras={() => checkout_is_open_update(false)}
          persona={false}
        ></Enviar>
      </Modal>
    </div>
  );
};

export default Shop_tiendas;
